import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=b20fef24&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=b20fef24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20fef24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b20fef24')) {
      api.createRecord('b20fef24', component.options)
    } else {
      api.reload('b20fef24', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=b20fef24&scoped=true&", function () {
      api.rerender('b20fef24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2BUqyg5wWuhI0/JS/comp/Voucher.vue"
export default component.exports